import {
    Analytics,
    Button,
    ErrorBoundary,
    Google,
    Hubspot,
    Navigation,
    Segment,
    Sentry,
    useViewerUnsafe
} from 'bigdatr-style';
import {Box} from 'bigdatr-style/layout';
import React, {useEffect} from 'react';
import {Switch} from 'react-router-dom';
import {routes} from './Router';
import useEventTracking from './useEventTracking';
import {useCountryUnsafe} from '~/feature/country/CountryContext';

export const publicRoutePaths = ['/creative/:creativeId/'];

const segment = new Segment(process.env.SEGMENT_WRITE_KEY_ENTERPRISE || '');
const hubspot = new Hubspot();
const googleAnalytics = new Google(process.env.GA_MEASUREMENT_ID || '');

const analytics = new Analytics({
    segment,
    // we don't care about logging errors in non-prod envs
    ...(process.env.STAGE === 'production' && {
        sentry: new Sentry({
            dsn: process.env.SENTRY_DSN ?? '',
            service: 'bigdatr-client-main',
            environment: process.env.STAGE ?? '',
            release: process.env.RELEASE_NAME ?? ''
        })
    }),
    hubspot,
    googleAnalytics
});

function PublicRoutes() {
    const {registerCtaClick} = useEventTracking();
    const isViewer = useViewerUnsafe();
    const release = process.env.RELEASE_NAME || '';
    const countryContext = useCountryUnsafe();
    const country = countryContext?.country;

    // Handle Anonymous non logged Users here
    useEffect(() => {
        if (!isViewer) {
            analytics.identify({
                id: 'anonymous',
                name: 'Anonymous - not logged on the app',
                release,
                activeCountry: country
            });
        }
    }, [isViewer, release]);

    return (
        <>
            <Navigation
                items={[
                    {
                        children: (
                            <Box onClick={() => registerCtaClick('navigationBar')}>
                                <Button href={`${process.env.BIGDATR_AUTH_URL}/register`}>
                                    Free Trial
                                </Button>
                            </Box>
                        )
                    },
                    {
                        to: {pathname: '/login', state: {from: window.location.pathname}},
                        children: <Button secondary children="Log in" />
                    }
                ]}
            />
            <ErrorBoundary>
                <Switch>{routes.singleCreative}</Switch>
            </ErrorBoundary>
        </>
    );
}

export default PublicRoutes;
